export default "__VITE_ASSET__c5f6f6b2__"